<div class="toggle-container">
  <span class="mode-label">Local Mode</span>
  <label class="switch">
      <input 
        type="checkbox" 
        [disabled]="disabled"
        [checked]="isRemoteMode" 
        (change)="toggleMode()"/>
      <span [ngClass]="{'slider': !disabled,'slider-disabled': disabled}"></span>
    </label>
    <span class="mode-label">Remote Mode</span>
  </div>
  